import * as types from './types';
import _ from 'lodash';
import moment from 'moment';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  transactionSummaryDates: [],
  fetchTransactionSummaryDateError: null,
  fetchTransactionSummaryDateLoading: false,
  transactionBeginEndDate: null,
  fetchTransactionBeginEndDateLoading: false,
  fetchTransactionBeginEndDateLoadingError: null,
  fetchExistingTranSummaryPrintLoading: false,
  fromDateMax: null,
  toDateMin: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_EXISTING_TRAN_SUMMARY_LIST_LOADING:
      return {
        ...state,
        fetchTransactionSummaryDateLoading: action.payload,
      };
    case types.GET_EXISTING_TRAN_SUMMARY_LIST_DATE_DATA:
      let transactionSummaryDates = action.payload
        ? action.payload.map(item => ({
            ...item,
            [TransactionSummaryEnum.BeginDT]: item[
              TransactionSummaryEnum.BeginDT
            ]
              ? moment(item[TransactionSummaryEnum.BeginDT]).format(
                  DATE_FORMAT_FOR_UI
                )
              : '',
            [TransactionSummaryEnum.EndDT]: item[TransactionSummaryEnum.EndDT]
              ? moment(item[TransactionSummaryEnum.EndDT]).format(
                  DATE_FORMAT_FOR_UI
                )
              : '',
          }))
        : [];
      return {
        ...state,
        transactionSummaryDates: transactionSummaryDates,
      };
    case types.GET_EXISTING_TRAN_SUMMARY_LIST_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const fetchTransactionSummaryDateError =
          action.payload.response.data.Errors;

        return {
          ...state,
          fetchTransactionSummaryDateError,
        };
      }
      return {
        ...state,
        fetchTransactionSummaryDateError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while loading transaction summary list. Please try again.',
        },
      };
    case types.SET_TRAN_SUMMARY_BEGIN_END_DATE:
      return {
        ...state,
        transactionBeginEndDate: action.payload,
      };
    case types.GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING:
      return {
        ...state,
        fetchTransactionBeginEndDateLoading: action.payload,
      };
    case types.GET_TRAN_SUMMARY_BEGIN_END_DATE_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const fetchTransactionBeginEndDateLoadingError =
          action.payload.response.data.Errors;

        return {
          ...state,
          fetchTransactionBeginEndDateLoadingError,
        };
      }
      return {
        ...state,
        fetchTransactionBeginEndDateLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while loading transaction begin and end date. Please try again.',
        },
      };
    case types.CLEAR_TRANSACTION_SUMMARY_ERROR:
      return {
        ...state,
        fetchTransactionSummaryDateError: null,
        fetchTransactionBeginEndDateLoadingError: null,
        fetchExistingTranSummaryPrintLoadingError: null,
      };
    case types.GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING:
      return {
        ...state,
        fetchExistingTranSummaryPrintLoading: action.payload,
      };
    case types.GET_EXISTING_TRAN_SUMMARY_PRINT_LOADING_ERROR:
      if (
        _.has(action.payload, 'response.data.Errors') &&
        action.payload.response.data.Errors.length
      ) {
        const fetchExistingTranSummaryPrintLoadingError =
          action.payload.response.data.Errors;

        return {
          ...state,
          fetchExistingTranSummaryPrintLoadingError,
        };
      }
      return {
        ...state,
        fetchExistingTranSummaryPrintLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while print Transaction Summary. Please try again.',
        },
      };
    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };
    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/TransactionSummaryList/reducer.js